export default RAILS_ASSET_URL("/footer_facebook.svg")
